import { Location, CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, ViewChild, ElementRef, ContentChildren, HostListener, NgModule, Directive, Optional, ViewContainerRef, ComponentFactoryResolver, Attribute, ChangeDetectorRef } from '@angular/core';
import * as i1 from '@angular/router';
import { NavigationEnd, Router, ActivatedRoute, RouterModule, RouterOutlet, PRIMARY_OUTLET, RouteReuseStrategy, ChildrenOutletContexts } from '@angular/router';
import { Type, Str, PopupModule, LocalizationModule, TooltipModule, LocaleService } from '@wke/ucc-angular-alt-common';
import { IconModule } from '@wke/ucc-icons';
import { BehaviorSubject } from 'rxjs';
import { filter, first } from 'rxjs/operators';
import { AlertService } from '@wke/ucc-angular-alt-overlay';
import { NgwkButtonStyle } from '@wke/ucc-angular-alt-buttons';
import { ModalService } from '@wke/ucc-angular-alt-modal';

/**
 * Servicio de los Breadcrumb.
 * Sirve principalmente para añadir nuevos Breadcrumb y obtener la lista de los Breadcrumb ya añadidos.
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@wke/ucc-icons';
import * as ɵngcc4 from '@wke/ucc-angular-alt-common';
import * as ɵngcc5 from '@wke/ucc-angular-alt-overlay';
import * as ɵngcc6 from '@wke/ucc-angular-alt-modal';

const _c0 = ["buttonContainer"];
const _c1 = ["tabsContainer"];
function TabBarComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵlistener("click", function TabBarComponent_div_5_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onMoreButtonClick(); });
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "locale");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "ucc-icon", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "more"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("key", ctx_r2.getIconKey());
} }
const _c2 = function (a0) { return { "background-color": a0 }; };
function TabBarComponent_ngwk_popup_6_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "button", 11);
    ɵngcc0.ɵɵlistener("click", function TabBarComponent_ngwk_popup_6_div_3_Template_button_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r10); const tabBarItemPopup_r8 = restoredCtx.$implicit; return tabBarItemPopup_r8.onClick(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tabBarItemPopup_r8 = ctx.$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(2, _c2, ctx_r7.getBackgroundColor(tabBarItemPopup_r8)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", tabBarItemPopup_r8.label, " ");
} }
function TabBarComponent_ngwk_popup_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ngwk-popup", 7, 8);
    ɵngcc0.ɵɵelementStart(2, "div", 9);
    ɵngcc0.ɵɵtemplate(3, TabBarComponent_ngwk_popup_6_div_3_Template, 3, 4, "div", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("anchor", _r1);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.tabBarItemsPopup);
} }
const _c3 = ["*"];
const _c4 = function (a0) { return { "sideBarSelectedColor": a0 }; };
const _c5 = [[["main-content"]], [["footer"]]];
const _c6 = function (a0) { return { "expand": a0 }; };
const _c7 = ["main-content", "footer"];
function BreadCrumbComponent_li_1_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 3);
    ɵngcc0.ɵɵlistener("click", function BreadCrumbComponent_li_1_span_1_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const breadcrumb_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.navigateTo(breadcrumb_r1); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const breadcrumb_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.spanClass(breadcrumb_r1));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", breadcrumb_r1.breadcrumbName, " ");
} }
function BreadCrumbComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtemplate(1, BreadCrumbComponent_li_1_span_1_Template, 2, 2, "span", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const breadcrumb_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", breadcrumb_r1.breadcrumbName);
} }
class BreadcrumbService {
    /** @ignore */
    constructor(_router) {
        this._router = _router;
        this._breadcrumbList = [];
        this._lastBreadcrumbNameSubscription = null;
        this._breadcrumbList$ = new BehaviorSubject(this._breadcrumbList);
        this._breadcumbs$ = this._breadcrumbList$.asObservable();
        const strBreadcrumbItems = sessionStorage.getItem(BREADCRUMB_STORAGE_KEY);
        if (strBreadcrumbItems) {
            this._router.events
                .pipe(filter((event) => event instanceof NavigationEnd), first()).subscribe(() => this.restore(JSON.parse(strBreadcrumbItems)));
        }
    }
    /**
     * Añade un nuevo Breadcrumb al listado, pasándole la instancia del componente que implementa la interfaz de BreadcrumbaParams.
     * @param component
     */
    addItem(component) {
        if (this.isInstanceofBreadcrumbable(component)) {
            let breadcrumbItem = {
                breadcrumbName: null,
                url: this._router.url
            };
            if (component.breadcrumbReset) {
                this.resetBreadcrumb();
            }
            this.insertNewBreadcrumb(breadcrumbItem);
            if (this._lastBreadcrumbNameSubscription && !this._lastBreadcrumbNameSubscription.closed) {
                this._lastBreadcrumbNameSubscription.unsubscribe();
            }
            this._lastBreadcrumbNameSubscription = component.breadcrumbName.subscribe((breadcrumbName) => {
                this.changeLastLabel(breadcrumbName);
                this.save();
            });
            this._breadcrumbList$.next(this.breadcrumbList);
        }
    }
    /**
     * Cambia la URL del enlance en el último elemento del breadcrumb.
     * @param newUrl
     */
    replaceLastUrl(newUrl) {
        if (this.breadcrumbList && this.breadcrumbList.length > 0) {
            const lastBreadcrumbItem = this.breadcrumbList[this.breadcrumbList.length - 1];
            lastBreadcrumbItem.url = newUrl;
            this.save();
        }
    }
    /**
     * Cambia la label del último elemento del breadcrumb.
     * @param newLabel
     */
    changeLastLabel(newLabel) {
        if (this.breadcrumbList && this.breadcrumbList.length > 0) {
            const lastBreadcrumbItem = this.breadcrumbList[this.breadcrumbList.length - 1];
            lastBreadcrumbItem.breadcrumbName = newLabel;
            this.save();
        }
    }
    //#region Private Methods
    isInstanceofBreadcrumbable(object) {
        return object.breadcrumbName !== undefined;
    }
    resetBreadcrumb() {
        this._breadcrumbList = [];
    }
    insertNewBreadcrumb(breadcrumb) {
        const indexBreadcrumbOnBreadcrumbList = this._breadcrumbList.findIndex((item) => this.areEqualsBreadcrumbItem(item, breadcrumb));
        if (indexBreadcrumbOnBreadcrumbList > -1) {
            this._breadcrumbList.splice(indexBreadcrumbOnBreadcrumbList + 1);
        }
        else {
            this._breadcrumbList.push(breadcrumb);
        }
    }
    areEqualsBreadcrumbItem(item, breadcrumb) {
        return this.normalizeUrl(item.url) === this.normalizeUrl(breadcrumb.url);
    }
    normalizeUrl(url) {
        return url.replace(/^\/|\/$/g, '');
    }
    restore(breadcrumbItems) {
        if (this._router.url === breadcrumbItems[breadcrumbItems.length - 1].url) {
            this._breadcrumbList = breadcrumbItems;
            this._breadcrumbList$.next(this.breadcrumbList);
            this.save();
        }
    }
    save() {
        sessionStorage.setItem(BREADCRUMB_STORAGE_KEY, JSON.stringify(this.breadcrumbList));
    }
    //#endregion
    /**
     * Obtiene el listado de Breadcrumbs actuales en la navegación de la aplicación.
     */
    get breadcrumbList() {
        return this._breadcrumbList;
    }
    /**
   * Emite el listado de Breadcrumbs actuales en la navegación de la aplicación.
   */
    get breadcrumbs$() {
        return this._breadcumbs$;
    }
}
BreadcrumbService.ɵfac = function BreadcrumbService_Factory(t) { return new (t || BreadcrumbService)(ɵngcc0.ɵɵinject(ɵngcc1.Router)); };
/** @nocollapse */ BreadcrumbService.ɵprov = i0.ɵɵdefineInjectable({ factory: function BreadcrumbService_Factory() { return new BreadcrumbService(i0.ɵɵinject(i1.Router)); }, token: BreadcrumbService, providedIn: "root" });
/** @nocollapse */
BreadcrumbService.ctorParameters = () => [
    { type: Router }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BreadcrumbService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.Router }]; }, null); })();
/** @ignore */
const BREADCRUMB_STORAGE_KEY = 'breadcrumb_history';

/**
 * Servicio de navegación de la aplicación
 */
class NavigationService {
    /** @ignore */
    constructor(_router, _location, _breadcrumbService) {
        this._router = _router;
        this._location = _location;
        this._breadcrumbService = _breadcrumbService;
        this._backClicked = false;
        this._location.subscribe(() => {
            this.backClicked = true;
            return false;
        });
    }
    /**
     * Método que permite navegar o ejecutar un método, según lo que se reciba por el parámetro 'link' de tipo [navigationLink]{@link navigationLink}
     * En el caso de que sea para navegar a otro enlace, se pueden pasar unos parámetros opcionales
     *
     * @param link Parámetro utilizado para navegar o ejecutar un método
     * @param params En el caso de que sea un link para navegar, se le pueden declarar parámetros extras
     */
    go(link, params) {
        if (Type.isFunction(link)) {
            link();
        }
        else if (Str.isString(link)) {
            return this.routerNavigate(link, params);
        }
    }
    /**
     * Método que permite navegar y al cual se le pueden pasar unos parámetros opcionales
     *
     * @param link Parámetro utilizado para navegar
     * @param params Parámetro para pasar opciones extras al link
     */
    routerNavigate(link, params) {
        return this._router.navigate([link], params);
    }
    /**
     * Permite reemplazar la URL actual por la pasada por parámetro
     *
     * @param newUrl Nueva URL para reemplazar
     */
    replaceBrowserURL(newUrl) {
        this._location.replaceState(newUrl);
        this._breadcrumbService.replaceLastUrl(newUrl);
    }
    /**
     * Método para volver a la página anterior en la que se encontraba el usuario
     */
    back() {
        this._location.back();
    }
    /**
     * Permite consultar si el usuario ha vuelto a la página anterior o no
     */
    get backClicked() {
        return this._backClicked;
    }
    /**
     * Permite definir si el usuario ha vuelto a la página anterior o no
     */
    set backClicked(value) {
        this._backClicked = value;
    }
}
NavigationService.ɵfac = function NavigationService_Factory(t) { return new (t || NavigationService)(ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(ɵngcc2.Location), ɵngcc0.ɵɵinject(BreadcrumbService)); };
NavigationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NavigationService, factory: NavigationService.ɵfac });
/** @nocollapse */
NavigationService.ctorParameters = () => [
    { type: Router },
    { type: Location },
    { type: BreadcrumbService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavigationService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.Router }, { type: ɵngcc2.Location }, { type: BreadcrumbService }]; }, null); })();

/**
 * Este componente utiliza la interfaz [BarItem]{@link BarItem} y tiene como objetivo declarar un tab item, el cual funciona a modo de
 * enlace hacia donde apunte su propiedad 'route'
 *
 * @example
 * <ngwk-tab [label]="tab.label" [route]="tab.navigationAction" [icon]="tab.icon"></ngwk-tab>
 */
class TabBarItemComponent {
    /**@ignore */
    constructor(_router, _activatedRoute, _navigationService) {
        this._router = _router;
        this._activatedRoute = _activatedRoute;
        this._navigationService = _navigationService;
        this.hidden = false;
        this.item = {
            label: null,
            navigationAction: null,
            icon: null
        };
        /** Permite cambiar la propiedad skipLocationChange del NavigationExtras del método "go" del NavigationService que se ejecuta al hacer click en el TabBarItem. Por defecto está a true */
        this.skipLocationChange = true;
        /** Permite saber cuando se ha cambiado la selección de un TabBarItem */
        this.selectionChange = new EventEmitter();
    }
    /** @ignore */
    onClick() {
        this._navigationService.go(this.item.navigationAction, { relativeTo: this._activatedRoute, skipLocationChange: this.skipLocationChange }).then(() => {
            this.selectionChange.emit();
        });
    }
    /** @ignore */
    get isSelected() {
        return Str.isString(this.item.navigationAction) && this._router.url.includes(this.item.navigationAction);
    }
    /**
     * Permite obtener el label del TabBarItem
     */
    get label() {
        return this.item.label;
    }
    /**
     * Permite definir el label del TabBarItem
     *
     * @param value El label del TabBarItem
     */
    set label(value) {
        this.item.label = value;
    }
    /**
     * Permite obtener la ruta a la que apunta el TabBarItem
     */
    get route() {
        return this.item.navigationAction;
    }
    /**
     * Permite definir la ruta a la que apunta el TabBarItem
     *
     * @param value La ruta a la que apunta el TabBarItem
     */
    set route(value) {
        this.item.navigationAction = value;
    }
    /**
     * Permite obtener el icono del TabBarItem
     */
    get icon() {
        return this.item.icon;
    }
    /**
     * Permite definir el icono del TabBarItem
     *
     * @param value El icono del TabBarItem
     */
    set icon(value) {
        this.item.icon = value;
    }
}
TabBarItemComponent.ɵfac = function TabBarItemComponent_Factory(t) { return new (t || TabBarItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(NavigationService)); };
TabBarItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TabBarItemComponent, selectors: [["ngwk-tab"]], inputs: { skipLocationChange: "skipLocationChange", label: "label", route: "route", icon: "icon" }, outputs: { selectionChange: "selectionChange" }, decls: 5, vars: 4, consts: [[3, "hidden"], ["skipLocationChange", "", 1, "wkTab", "horizontalLayout", "colAuto", 3, "ngClass", "click"], [1, "colAvailable"], [3, "ngClass"]], template: function TabBarItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function TabBarItemComponent_Template_div_click_1_listener() { return ctx.onClick(); });
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(4, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", ctx.hidden);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.isSelected ? "tabSelectedColor" : "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.item == null ? null : ctx.item.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.isSelected ? "tabSelectedBorder" : "");
    } }, directives: [ɵngcc2.NgClass], encapsulation: 2 });
/** @nocollapse */
TabBarItemComponent.ctorParameters = () => [
    { type: Router },
    { type: ActivatedRoute },
    { type: NavigationService }
];
TabBarItemComponent.propDecorators = {
    skipLocationChange: [{ type: Input }],
    selectionChange: [{ type: Output }],
    label: [{ type: Input }],
    route: [{ type: Input }],
    icon: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabBarItemComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-tab',
                template: "<div [hidden]=\"hidden\">\r\n    <div class='wkTab horizontalLayout colAuto' [ngClass]=\"isSelected ? 'tabSelectedColor' : ''\" (click)='onClick()' skipLocationChange>\r\n        <span class='colAvailable'>{{item?.label}}</span>\r\n    </div>\r\n    <div [ngClass]=\"isSelected ? 'tabSelectedBorder' : ''\"></div>\r\n</div>\r\n"
            }]
    }], function () { return [{ type: ɵngcc1.Router }, { type: ɵngcc1.ActivatedRoute }, { type: NavigationService }]; }, { skipLocationChange: [{
            type: Input
        }], selectionChange: [{
            type: Output
        }], label: [{
            type: Input
        }], route: [{
            type: Input
        }], icon: [{
            type: Input
        }] }); })();

/**
 * Este componente funciona a modo de contenedor, donde se le declara una serie de [TabBarItemComponents]{@link TabBarItemComponent},
 * todos y cada uno de ellos con su propia configuración: nombre, enlace e icono
 *
 * @example
 * <ngwk-tab-bar>
 *      <ngwk-tab [label]="firstTab.label" [route]="firstTab.navigationAction" [icon]="firstTab.icon"></ngwk-tab>
 *      <ngwk-tab [label]="secondTab.label" [route]="secondTab.navigationAction" [icon]="secondTab.icon"></ngwk-tab>
 *      <ngwk-tab [label]="thirdTab.label" [route]="thirdTab.navigationAction" [icon]="thirdTab.icon"></ngwk-tab>
 * </ngwk-tab-bar>
 */
class TabBarComponent {
    constructor() {
        this._originalTabBarItemsWidths = [];
        this._tabBarItemsAccumulativeWidths = [];
        this._tabBarItemsPopup = [];
        this._isPopupOpen = false;
    }
    /** @ignore */
    ngAfterViewInit() {
        this.onTabsChange();
        this.onTabIsSelectedSubscription();
        this.prevWidthCalculations();
        this.widthCalculations();
        setTimeout(() => this.onResize());
    }
    /** @ignore */
    onResize() {
        this._tabBarItemsPopup = [];
        const visibleTabBarWidth = this._tabsContainer.nativeElement.offsetWidth;
        this._tabBarItemsAccumulativeWidths.forEach((width, index) => {
            if (width > visibleTabBarWidth && !this._allTabBarItems.toArray()[index].isSelected) {
                this._tabBarItemsPopup.push(this._allTabBarItems.toArray()[index]);
                this._allTabBarItems.toArray()[index].hidden = true;
            }
            else {
                this._allTabBarItems.toArray()[index].hidden = false;
            }
        });
    }
    /**@ignore */
    documentClick(event) {
        if (!this.contains(event.target)) {
            this._isPopupOpen = false;
        }
    }
    contains(target) {
        return this._moreButton ? this._moreButton.nativeElement.contains(target) : false;
    }
    onTabsChange() {
        this._allTabBarItems.changes.subscribe(() => {
            setTimeout(() => {
                this.prevWidthCalculations();
                this.widthCalculations();
                this.onResize();
            });
        });
    }
    onTabIsSelectedSubscription() {
        this._allTabBarItems.forEach((item) => {
            item.selectionChange.subscribe(() => {
                this.widthCalculations();
                this.onResize();
            });
        });
    }
    prevWidthCalculations() {
        this._allTabBarItemsElementRef.forEach((item) => {
            this._originalTabBarItemsWidths.push(item.nativeElement.offsetWidth);
        });
    }
    widthCalculations() {
        this._tabBarItemsAccumulativeWidths = [];
        let accumulativeWidth = 60 + 20;
        this._allTabBarItemsElementRef.forEach((item, tabBarItemsElementRefIndex) => {
            accumulativeWidth += this._originalTabBarItemsWidths[tabBarItemsElementRefIndex];
            if (this._allTabBarItems.toArray()[tabBarItemsElementRefIndex].isSelected) {
                this._tabBarItemsAccumulativeWidths.forEach((number, tabBarItemsAccumulativeWidthsIndex, array) => {
                    array[tabBarItemsAccumulativeWidthsIndex] += this._originalTabBarItemsWidths[tabBarItemsElementRefIndex];
                });
            }
            this._tabBarItemsAccumulativeWidths.push(accumulativeWidth);
        });
    }
    /** @ignore */
    getBackgroundColor(tabBarItem) {
        return tabBarItem.isSelected ? '#EBFAFF' : '';
    }
    /** @ignore */
    popupHasItems() {
        return this._tabBarItemsPopup.length > 0;
    }
    /** @ignore */
    get tabBarItemsPopup() {
        return this._tabBarItemsPopup;
    }
    /** @ignore */
    onMoreButtonClick() {
        this._isPopupOpen = !this._isPopupOpen;
    }
    /** @ignore */
    getIconKey() {
        return this._isPopupOpen ? 'sortAscendingIcon' : 'sortDescendingIcon';
    }
    /** @ignore */
    get isPopupOpen() {
        return this._isPopupOpen;
    }
}
TabBarComponent.ɵfac = function TabBarComponent_Factory(t) { return new (t || TabBarComponent)(); };
TabBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TabBarComponent, selectors: [["ngwk-tab-bar"]], contentQueries: function TabBarComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TabBarItemComponent, 4);
        ɵngcc0.ɵɵcontentQuery(dirIndex, TabBarItemComponent, 4, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._allTabBarItems = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._allTabBarItemsElementRef = _t);
    } }, viewQuery: function TabBarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c1, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._moreButton = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._tabsContainer = _t.first);
    } }, hostBindings: function TabBarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function TabBarComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow)("click", function TabBarComponent_click_HostBindingHandler($event) { return ctx.documentClick($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, ngContentSelectors: _c3, decls: 7, vars: 2, consts: [["id", "tabs", 1, "horizontalLayout", "wkTabBar"], ["tabsContainer", ""], ["buttonContainer", ""], ["class", "moreTabsButton horizontalLayout", 3, "click", 4, "ngIf"], [3, "anchor", 4, "ngIf"], [1, "moreTabsButton", "horizontalLayout", 3, "click"], [1, "moreTabsIcon", 3, "key"], [3, "anchor"], ["popup", ""], [1, "verticalLayout", "menuPopupContent"], [4, "ngFor", "ngForOf"], [2, "width", "100%", 3, "ngStyle", "click"]], template: function TabBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementStart(3, "div", null, 2);
        ɵngcc0.ɵɵtemplate(5, TabBarComponent_div_5_Template, 5, 4, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, TabBarComponent_ngwk_popup_6_Template, 4, 2, "ngwk-popup", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.popupHasItems());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isPopupOpen && ctx.tabBarItemsPopup.length > 0);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.IconComponent, ɵngcc4.PopupComponent, ɵngcc2.NgForOf, ɵngcc2.NgStyle], pipes: [ɵngcc4.LocalePipe], styles: ["[_nghost-%COMP%]     .wkTabBar{width:100%;min-height:41px;background-color:#fff;color:#888;transition:width .5s ease;cursor:default;user-select:none;text-transform:uppercase;font-size:11px;border-bottom:1px solid #ccc;text-align:center;white-space:nowrap;padding:0 15px;overflow-x:hidden}[_nghost-%COMP%]     .wkTabBar ul{list-style-type:none;margin:0;padding:0}[_nghost-%COMP%]     .wkTabBar li{float:left}[_nghost-%COMP%]     .wkTabBar ul .wkTab, [_nghost-%COMP%]     .wkTab{height:40px;line-height:40px;width:100%;overflow:hidden;vertical-align:middle;display:flex;cursor:pointer;padding:0 10px}[_nghost-%COMP%]     .wkTabBar ul .wkTab span, [_nghost-%COMP%]     .wkTab span{width:100%!important;opacity:1!important}[_nghost-%COMP%]     .wkTabBar ul .wkTab a, [_nghost-%COMP%]     .wkTab a{color:#fff;text-decoration:none;font-size:11px}[_nghost-%COMP%]     .wkTabBar ul .wkTab:hover, [_nghost-%COMP%]     .wkTab:hover{background-color:#f8f8f8}[_nghost-%COMP%]     .tabSelectedColor{background-color:transparent;color:#000}[_nghost-%COMP%]     .tabSelectedColor:hover{background-color:transparent!important}[_nghost-%COMP%]     .tabSelectedBorder{border-bottom:4px solid #FA9200;margin-top:-4px;z-index:2;width:100%;animation:tabHover;animation-duration:.3s;transition-timing-function:ease-in}@keyframes tabHover{0%{opacity:1;width:0%}to{width:100%;opacity:1}}[_nghost-%COMP%]     .moreTabsButton{background-color:#fff;color:#888;height:40px;line-height:40px;width:100%;overflow:hidden;vertical-align:middle;display:flex;cursor:pointer;padding:0 10px}[_nghost-%COMP%]     .moreTabsButton:hover{background-color:#f8f8f8}[_nghost-%COMP%]     .moreTabsIcon i{margin-left:3px;font-size:7px;line-height:40px}"] });
TabBarComponent.propDecorators = {
    _moreButton: [{ type: ViewChild, args: ['buttonContainer', { read: ElementRef },] }],
    _tabsContainer: [{ type: ViewChild, args: ['tabsContainer', { read: ElementRef },] }],
    _allTabBarItems: [{ type: ContentChildren, args: [TabBarItemComponent,] }],
    _allTabBarItemsElementRef: [{ type: ContentChildren, args: [TabBarItemComponent, { read: ElementRef },] }],
    onResize: [{ type: HostListener, args: ["window:resize",] }],
    documentClick: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabBarComponent, [{
        type: Component,
        args: [{
                selector: "ngwk-tab-bar",
                template: "<div #tabsContainer id=\"tabs\" class=\"horizontalLayout wkTabBar\">\r\n    <ng-content></ng-content>\r\n    <div #buttonContainer>\r\n        <div *ngIf=\"popupHasItems()\" class=\"moreTabsButton horizontalLayout\" (click)=\"onMoreButtonClick()\">\r\n            <span>{{ \"more\" | locale }}</span>\r\n            <ucc-icon class=\"moreTabsIcon\" [key]=\"getIconKey()\"></ucc-icon>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<ngwk-popup #popup *ngIf=\"isPopupOpen && tabBarItemsPopup.length > 0\" [anchor]=\"buttonContainer\">\r\n    <div class=\"verticalLayout menuPopupContent\">\r\n        <div *ngFor=\"let tabBarItemPopup of tabBarItemsPopup\">\r\n            <button (click)='tabBarItemPopup.onClick()' style=\"width: 100%;\" [ngStyle]=\"{'background-color': getBackgroundColor(tabBarItemPopup)}\"> \r\n                {{ tabBarItemPopup.label }}\r\n            </button>\r\n        </div>\r\n    </div>\r\n</ngwk-popup>",
                styles: [":host ::ng-deep .wkTabBar{width:100%;min-height:41px;background-color:#fff;color:#888;transition:width .5s ease;cursor:default;user-select:none;text-transform:uppercase;font-size:11px;border-bottom:1px solid #ccc;text-align:center;white-space:nowrap;padding:0 15px;overflow-x:hidden}:host ::ng-deep .wkTabBar ul{list-style-type:none;margin:0;padding:0}:host ::ng-deep .wkTabBar li{float:left}:host ::ng-deep .wkTabBar ul .wkTab,:host ::ng-deep .wkTab{height:40px;line-height:40px;width:100%;overflow:hidden;vertical-align:middle;display:flex;cursor:pointer;padding:0 10px}:host ::ng-deep .wkTabBar ul .wkTab span,:host ::ng-deep .wkTab span{width:100%!important;opacity:1!important}:host ::ng-deep .wkTabBar ul .wkTab a,:host ::ng-deep .wkTab a{color:#fff;text-decoration:none;font-size:11px}:host ::ng-deep .wkTabBar ul .wkTab:hover,:host ::ng-deep .wkTab:hover{background-color:#f8f8f8}:host ::ng-deep .tabSelectedColor{background-color:transparent;color:#000}:host ::ng-deep .tabSelectedColor:hover{background-color:transparent!important}:host ::ng-deep .tabSelectedBorder{border-bottom:4px solid #FA9200;margin-top:-4px;z-index:2;width:100%;animation:tabHover;animation-duration:.3s;transition-timing-function:ease-in}@keyframes tabHover{0%{opacity:1;width:0%}to{width:100%;opacity:1}}:host ::ng-deep .moreTabsButton{background-color:#fff;color:#888;height:40px;line-height:40px;width:100%;overflow:hidden;vertical-align:middle;display:flex;cursor:pointer;padding:0 10px}:host ::ng-deep .moreTabsButton:hover{background-color:#f8f8f8}:host ::ng-deep .moreTabsIcon i{margin-left:3px;font-size:7px;line-height:40px}\n"]
            }]
    }], function () { return []; }, { 
    /** @ignore */
    onResize: [{
            type: HostListener,
            args: ["window:resize"]
        }], 
    /**@ignore */
    documentClick: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], _moreButton: [{
            type: ViewChild,
            args: ['buttonContainer', { read: ElementRef }]
        }], _tabsContainer: [{
            type: ViewChild,
            args: ['tabsContainer', { read: ElementRef }]
        }], _allTabBarItems: [{
            type: ContentChildren,
            args: [TabBarItemComponent]
        }], _allTabBarItemsElementRef: [{
            type: ContentChildren,
            args: [TabBarItemComponent, { read: ElementRef }]
        }] }); })();

class TabBarModule {
}
TabBarModule.ɵfac = function TabBarModule_Factory(t) { return new (t || TabBarModule)(); };
TabBarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TabBarModule });
TabBarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            RouterModule,
            PopupModule,
            IconModule,
            LocalizationModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabBarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    RouterModule,
                    PopupModule,
                    IconModule,
                    LocalizationModule
                ],
                declarations: [
                    TabBarComponent,
                    TabBarItemComponent
                ],
                exports: [
                    TabBarComponent,
                    TabBarItemComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TabBarModule, { declarations: function () { return [TabBarComponent, TabBarItemComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        RouterModule,
        PopupModule,
        IconModule,
        LocalizationModule]; }, exports: function () { return [TabBarComponent, TabBarItemComponent]; } }); })();

/**
 * Este componente tiene una serie de Inputs relacionados con la interfaz [SideBarItem]{@link SideBarItem} y tiene como objetivo
 * declarar un botón el cual funciona a modo de enlace hacia donde apunte su Input 'route'
 *
 * @example
 *          <ngwk-side-bar-item
 *            [label]="itemOne.label"
 *            [route]="itemOne.navigationAction"
 *            [itemTooltip]="itemOne.tooltip"
 *            [icon]="itemOne.icon">
 *          </ngwk-side-bar-item>
 */
class SideBarItemComponent {
    /**@ignore */
    constructor(_router) {
        this._router = _router;
        /** Permite activar o desactivar el estado de extendido del SideBar */
        this.isSideBarExpanded = null;
        /** Permite obtener el item definido en el SideBarItem */
        this.item = {
            id: null,
            label: null,
            navigationAction: null,
            tooltipText: null,
            icon: null
        };
    }
    ngOnInit() {
        if (this.item.tooltipText === null) {
            this.item.tooltipText = this.item.label;
        }
    }
    /** @ignore */
    isSelected() {
        if (Str.isString(this.item.navigationAction)) {
            return this._router.url.includes(this.item.navigationAction);
        }
    }
    /**
     * Permite obtener el id del SideBarItem
     */
    get id() {
        return this.item.id;
    }
    /**
     * Permite definir el id del SideBarItem
     *
     * @param value El id del SideBarItem
     */
    set id(value) {
        this.item.id = value;
    }
    /**
     * Permite obtener el texto de la label cuando está extendido
     */
    get label() {
        return this.item.label;
    }
    /**
     * Permite definir el texto de la label cuando está extendido
     *
     * @param value El texto de la label
     */
    set label(value) {
        this.item.label = value;
    }
    /**
     * Permite obtener la ruta del componente a la cual el usuario accederá al darle click
     */
    get route() {
        return this.item.navigationAction;
    }
    /**
     * Permite definir la ruta del componente a la cual el usuario accederá al darle click
     *
     * @param value la ruta del componente
     */
    set route(value) {
        this.item.navigationAction = value;
    }
    /**
     * Permite obtener el texto del Tooltip cuando el componente no está extendido
     */
    get tooltipText() {
        return this.item.tooltipText;
    }
    /**
     * Permite definir el texto del Tooltip cuando el componente no está extendido
     *
     * @param value El texto del Tooltip
     */
    set tooltipText(value) {
        this.item.tooltipText = value;
    }
    /**
     * Permite obtener el icono del SideBarItem, que aparecerá tanto cuando está extendido como cuando no lo está
     */
    get icon() {
        return this.item.icon;
    }
    /**
     * Permite definir el icono del SideBarItem, que aparecerá tanto cuando está extendido como cuando no lo está
     *
     * @param value El icono del SideBarItem
     */
    set icon(value) {
        this.item.icon = value;
    }
}
SideBarItemComponent.ɵfac = function SideBarItemComponent_Factory(t) { return new (t || SideBarItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router)); };
SideBarItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SideBarItemComponent, selectors: [["ngwk-side-bar-item"]], inputs: { id: "id", label: "label", route: "route", tooltipText: "tooltipText", icon: "icon" }, decls: 6, vars: 9, consts: [[1, "sideBarItem", "horizontalLayout", 3, "id", "ngClass", "routerLink"], ["ngwkTooltipPosition", "right", 1, "colAuto", "sideBarItemIconColumn", "alignMiddle", 3, "ngwkTooltip", "ngwkTooltipDisable"], [3, "key"], [1, "colAvailable", "alignVerticalMiddle"]], template: function SideBarItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "ucc-icon", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "span");
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.item == null ? null : ctx.item.id)("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c4, ctx.isSelected()))("routerLink", ctx.item == null ? null : ctx.item.navigationAction);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngwkTooltip", ctx.item == null ? null : ctx.item.tooltipText)("ngwkTooltipDisable", ctx.isSideBarExpanded);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("key", ctx.item == null ? null : ctx.item.icon);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.item == null ? null : ctx.item.label);
    } }, directives: [ɵngcc2.NgClass, ɵngcc1.RouterLink, ɵngcc4.NgwkTooltipDirective, ɵngcc3.IconComponent], encapsulation: 2 });
/** @nocollapse */
SideBarItemComponent.ctorParameters = () => [
    { type: Router }
];
SideBarItemComponent.propDecorators = {
    id: [{ type: Input }],
    label: [{ type: Input }],
    route: [{ type: Input }],
    tooltipText: [{ type: Input }],
    icon: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideBarItemComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-side-bar-item',
                template: "<div class='sideBarItem horizontalLayout' [id]=\"item?.id\" [ngClass]=\"{ 'sideBarSelectedColor' : isSelected() }\" [routerLink]=\"item?.navigationAction\">\r\n    <div class='colAuto sideBarItemIconColumn alignMiddle' [ngwkTooltip]=\"item?.tooltipText\" [ngwkTooltipDisable]=\"isSideBarExpanded\" ngwkTooltipPosition='right'>\r\n        <ucc-icon [key]='item?.icon'></ucc-icon>\r\n    </div>\r\n    <div class='colAvailable alignVerticalMiddle'>\r\n        <span>{{item?.label}}</span>\r\n    </div>\r\n</div>\r\n"
            }]
    }], function () { return [{ type: ɵngcc1.Router }]; }, { id: [{
            type: Input
        }], label: [{
            type: Input
        }], route: [{
            type: Input
        }], tooltipText: [{
            type: Input
        }], icon: [{
            type: Input
        }] }); })();

/**
 * Este componente funciona a modo de menu lateral con una sección de contenido general y otra sección inferior llamada footer.
 * Este menu se puede expander para ver con más detalle cada una de las zonas de éste menu. Utiliza una serie de
 * [SideBarItems]{@link SideBarItemComponent}, todos y cada uno de ellos con su propia configuración
 *
 * @example
 * <ngwk-side-bar>
 *      <div main-content>
 *          <ngwk-side-bar-item
 *            [label]="itemOne.label"
 *            [route]="itemOne.navigationAction"
 *            [itemTooltip]="itemOne.tooltip"
 *            [icon]="itemOne.icon">
 *          </ngwk-side-bar-item>
 *          <ngwk-side-bar-item
 *            [label]="itemTwo.label"
 *            [route]="itemTwo.navigationAction"
 *            [itemTooltip]="itemTwo.tooltip"
 *            [icon]="itemTwo.icon">
 *          </ngwk-side-bar-item>
 *      </div>
 *      <div footer>
 *          <ngwk-side-bar-item
 *            [label]="itemThree.label"
 *            [route]="itemThree.navigationAction"
 *            [itemTooltip]="itemThree.tooltip"
 *            [icon]="itemThree.icon">
 *          </ngwk-side-bar-item>
 *      </div>
 *    </ngwk-side-bar>
 */
class SideBarComponent {
    /**@ignore */
    constructor(_el) {
        this._el = _el;
        this._expanded = false;
    }
    /**@ignore */
    onDocumentClick(event) {
        if (this.expanded && (!this._el.nativeElement.contains(event.target) || this.isSideBarItem(event.target))) {
            this.expanded = false;
        }
    }
    isSideBarItem(target) {
        return (this._sideBarItemsElementRefs &&
            this._sideBarItemsElementRefs.some((sbi) => sbi.nativeElement.contains(target)));
    }
    manageSideBarItemsTooltip() {
        this._sideBarItems.forEach((sideBarItem) => sideBarItem.isSideBarExpanded = this.expanded);
    }
    /** @ignore */
    onExpand() {
        this.expanded = !this.expanded;
    }
    /**
     * Permite consultar si el SideBar está en estado de extendido o no
     *
     * @returns
     */
    get expanded() {
        return this._expanded;
    }
    /**
     * Permite activar o desactivar el estado de extendido del SideBar
     *
     * @param value Valor que activa o desactiva el estado de extendido
     * @returns
     */
    set expanded(value) {
        this._expanded = value;
        this.manageSideBarItemsTooltip();
    }
}
SideBarComponent.ɵfac = function SideBarComponent_Factory(t) { return new (t || SideBarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SideBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SideBarComponent, selectors: [["ngwk-side-bar"]], contentQueries: function SideBarComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, SideBarItemComponent, 4, ElementRef);
        ɵngcc0.ɵɵcontentQuery(dirIndex, SideBarItemComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._sideBarItemsElementRefs = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._sideBarItems = _t);
    } }, hostBindings: function SideBarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function SideBarComponent_click_HostBindingHandler($event) { return ctx.onDocumentClick($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { expanded: "expanded" }, ngContentSelectors: _c7, decls: 12, vars: 6, consts: [["id", "sideMenu", 1, "verticalLayout", "sideBar", 3, "ngClass"], [1, "rowAuto", "horizontalLayout", "alignMiddle", "collapseButtonRegion", "alignHorizontalCenter", 3, "click"], [1, "colAuto", "displayFlex", "collapseTextArea"], [1, "collapseText"], [1, "colAuto", "displayFlex", "collapseButton"], ["key", "angle-left"], [1, "rowAvailable"], [1, "rowAuto"]], template: function SideBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c5);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function SideBarComponent_Template_div_click_1_listener() { return ctx.onExpand(); });
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵpipe(5, "locale");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelement(7, "ucc-icon", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵprojection(9, 0, ["(click)", "onExpand()"]);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 7);
        ɵngcc0.ɵɵprojection(11, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c6, ctx.expanded));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 2, "collapse_menu"));
    } }, directives: [ɵngcc2.NgClass, ɵngcc3.IconComponent], pipes: [ɵngcc4.LocalePipe], styles: ["[_nghost-%COMP%]     .sideBar{width:60px;font-size:13px;height:100%;background-color:#474747;color:#fff;transition:width .5s ease;cursor:default;overflow-x:hidden;-webkit-touch-callout:none;-o-user-select:none;user-select:none}[_nghost-%COMP%]     .sideBar.expand{width:260px}[_nghost-%COMP%]     .sideBar.expand .collapseTextArea{opacity:1;width:230px}[_nghost-%COMP%]     .sideBar.expand .collapseButton{margin-left:0;transform:rotate(0);margin-right:10px}[_nghost-%COMP%]     .sideBar .expanderItem{width:260px;height:34px;background-color:#474747;color:#fff;overflow:hidden;vertical-align:middle;display:flex;cursor:pointer}[_nghost-%COMP%]     .sideBar .expanderItem:hover, [_nghost-%COMP%]     .sideBar .expanderItem:hover{background-color:#789}[_nghost-%COMP%]     .sideBar .sideBarItem{height:49px;width:260px;overflow:hidden;vertical-align:middle;display:flex;cursor:pointer}[_nghost-%COMP%]     .sideBar .sideBarItem a{color:#fff;text-decoration:none;font-size:13px}[_nghost-%COMP%]     .sideBar .sideBarItem:hover{background-color:#8c8c8c;outline:none}[_nghost-%COMP%]     .sideBar .sideBarItem.sideBarSelectedColor{background-color:#e5e5e5;color:#0081c6}[_nghost-%COMP%]     .sideBar .sideBarItem.sideBarSelectedColor .sideBarItem:active{background-color:#e5e5e5}[_nghost-%COMP%]     .sideBar .sideBarItem.sideBarSelectedColor:focus{background-color:#e5e5e5;outline:none}[_nghost-%COMP%]     .sideBar .sideBarItem.sideBarSelectedColor:hover{background-color:#e5e5e5}[_nghost-%COMP%]     .sideBarItemIconColumn{width:60px;font-size:13px;outline:none}[_nghost-%COMP%]     .collapseButtonRegion{height:34px;display:flex;position:relative;cursor:pointer}[_nghost-%COMP%]     .collapseButtonRegion .collapseTextArea{width:0;opacity:0;transition:opacity .7s ease,width .5s ease}[_nghost-%COMP%]     .collapseButtonRegion .collapseTextArea .collapseText{width:100%;font-size:11px;color:#fff;text-align:right;white-space:nowrap;transition:opacity .5s ease;-webkit-transition:opacity .5s ease;-moz-transition:opacity .5s ease;-o-transition:opacity .5s ease;overflow:hidden}[_nghost-%COMP%]     .collapseButtonRegion .collapseButton{align-self:center;vertical-align:middle;margin-left:0;transform:rotate(180deg);transition:transform .3s ease;cursor:pointer}[_nghost-%COMP%]     .collapseButtonRegion .collapseButton i{font-size:11px}"] });
/** @nocollapse */
SideBarComponent.ctorParameters = () => [
    { type: ElementRef }
];
SideBarComponent.propDecorators = {
    _sideBarItemsElementRefs: [{ type: ContentChildren, args: [SideBarItemComponent, { read: ElementRef },] }],
    _sideBarItems: [{ type: ContentChildren, args: [SideBarItemComponent,] }],
    onDocumentClick: [{ type: HostListener, args: ['document:click', ['$event'],] }],
    expanded: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideBarComponent, [{
        type: Component,
        args: [{
                selector: "ngwk-side-bar",
                template: "<div id='sideMenu' class='verticalLayout sideBar' [ngClass]=\"{ 'expand' : expanded }\">\r\n    <div class=\"rowAuto horizontalLayout alignMiddle collapseButtonRegion alignHorizontalCenter\" (click)='onExpand()'>\r\n        <div class=\"colAuto displayFlex collapseTextArea\">\r\n          <span class=\"collapseText\">{{'collapse_menu' | locale}}</span>\r\n        </div>\r\n        <div class=\"colAuto displayFlex collapseButton\">\r\n          <ucc-icon key='angle-left'></ucc-icon>\r\n        </div>\r\n      </div>\r\n  <div class='rowAvailable'>\r\n    <ng-content select=\"main-content\" (click)='onExpand()'></ng-content>\r\n  </div>\r\n  <div class='rowAuto'>\r\n    <ng-content select=\"footer\"></ng-content>\r\n  </div>\r\n</div>\r\n",
                styles: [":host ::ng-deep .sideBar{width:60px;font-size:13px;height:100%;background-color:#474747;color:#fff;transition:width .5s ease;cursor:default;overflow-x:hidden;-webkit-touch-callout:none;-o-user-select:none;user-select:none}:host ::ng-deep .sideBar.expand{width:260px}:host ::ng-deep .sideBar.expand .collapseTextArea{opacity:1;width:230px}:host ::ng-deep .sideBar.expand .collapseButton{margin-left:0;transform:rotate(0);margin-right:10px}:host ::ng-deep .sideBar .expanderItem{width:260px;height:34px;background-color:#474747;color:#fff;overflow:hidden;vertical-align:middle;display:flex;cursor:pointer}:host ::ng-deep .sideBar .expanderItem:hover,:host ::ng-deep .sideBar .expanderItem:hover{background-color:#789}:host ::ng-deep .sideBar .sideBarItem{height:49px;width:260px;overflow:hidden;vertical-align:middle;display:flex;cursor:pointer}:host ::ng-deep .sideBar .sideBarItem a{color:#fff;text-decoration:none;font-size:13px}:host ::ng-deep .sideBar .sideBarItem:hover{background-color:#8c8c8c;outline:none}:host ::ng-deep .sideBar .sideBarItem.sideBarSelectedColor{background-color:#e5e5e5;color:#0081c6}:host ::ng-deep .sideBar .sideBarItem.sideBarSelectedColor .sideBarItem:active{background-color:#e5e5e5}:host ::ng-deep .sideBar .sideBarItem.sideBarSelectedColor:focus{background-color:#e5e5e5;outline:none}:host ::ng-deep .sideBar .sideBarItem.sideBarSelectedColor:hover{background-color:#e5e5e5}:host ::ng-deep .sideBarItemIconColumn{width:60px;font-size:13px;outline:none}:host ::ng-deep .collapseButtonRegion{height:34px;display:flex;position:relative;cursor:pointer}:host ::ng-deep .collapseButtonRegion .collapseTextArea{width:0;opacity:0;transition:opacity .7s ease,width .5s ease}:host ::ng-deep .collapseButtonRegion .collapseTextArea .collapseText{width:100%;font-size:11px;color:#fff;text-align:right;white-space:nowrap;transition:opacity .5s ease;-webkit-transition:opacity .5s ease;-moz-transition:opacity .5s ease;-o-transition:opacity .5s ease;overflow:hidden}:host ::ng-deep .collapseButtonRegion .collapseButton{align-self:center;vertical-align:middle;margin-left:0;transform:rotate(180deg);transition:transform .3s ease;cursor:pointer}:host ::ng-deep .collapseButtonRegion .collapseButton i{font-size:11px}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { 
    /**@ignore */
    onDocumentClick: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], expanded: [{
            type: Input
        }], _sideBarItemsElementRefs: [{
            type: ContentChildren,
            args: [SideBarItemComponent, { read: ElementRef }]
        }], _sideBarItems: [{
            type: ContentChildren,
            args: [SideBarItemComponent]
        }] }); })();

class SideBarModule {
}
SideBarModule.ɵfac = function SideBarModule_Factory(t) { return new (t || SideBarModule)(); };
SideBarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SideBarModule });
SideBarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            RouterModule,
            CommonModule,
            IconModule,
            TooltipModule,
            LocalizationModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideBarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    RouterModule,
                    CommonModule,
                    IconModule,
                    TooltipModule,
                    LocalizationModule
                ],
                declarations: [
                    SideBarComponent,
                    SideBarItemComponent
                ],
                exports: [
                    SideBarComponent,
                    SideBarItemComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SideBarModule, { declarations: function () { return [SideBarComponent, SideBarItemComponent]; }, imports: function () { return [RouterModule,
        CommonModule,
        IconModule,
        TooltipModule,
        LocalizationModule]; }, exports: function () { return [SideBarComponent, SideBarItemComponent]; } }); })();

/**
 * Este componente sirve para ayudar al usuario a hacer un seguimiento de la navegabilidad de la aplicación, indicandole
 * donde se situa actualmente y también permitiendole también poder volver a niveles de navegación anteriores a donde ha estado.
 * Este componente utilitza [Breadcrumbs]{@link Breadcrumb} que se van generando automáticamente a medida que el usuario navega
 * por la aplicación y [BreadcrumbService]{@link BreadcrumbService} para obtener la lista de dichos Breadcrumbs
 *
 * @example
 * <ngwk-breadcrumb></ngwk-breadcrumb>
 */
class BreadCrumbComponent {
    /** @ignore */
    constructor(_breadcrumbService, _navigationService) {
        this._breadcrumbService = _breadcrumbService;
        this._navigationService = _navigationService;
    }
    /** @ignore */
    navigateTo(item) {
        this._navigationService.go(item.url);
    }
    /** @ignore */
    spanClass(item) {
        if (item.url) {
            return 'wkBreadcrumbSpanPointer';
        }
        else {
            return 'wkBreadcrumbSpanNoPointer';
        }
    }
    /** @ignore */
    get breadcrumbs$() {
        return this._breadcrumbService.breadcrumbs$;
    }
}
BreadCrumbComponent.ɵfac = function BreadCrumbComponent_Factory(t) { return new (t || BreadCrumbComponent)(ɵngcc0.ɵɵdirectiveInject(BreadcrumbService), ɵngcc0.ɵɵdirectiveInject(NavigationService)); };
BreadCrumbComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BreadCrumbComponent, selectors: [["ngwk-breadcrumb"]], decls: 4, vars: 6, consts: [[1, "wkBreadcrumb", "alignVerticalMiddle"], [4, "ngFor", "ngForOf"], [3, "ngClass", "click", 4, "ngIf"], [3, "ngClass", "click"]], template: function BreadCrumbComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, BreadCrumbComponent_li_1_Template, 2, 1, "li", 1);
        ɵngcc0.ɵɵpipe(2, "slice");
        ɵngcc0.ɵɵpipe(3, "async");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(2, 1, ɵngcc0.ɵɵpipeBind1(3, 4, ctx.breadcrumbs$), -3));
    } }, directives: [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgClass], pipes: [ɵngcc2.SlicePipe, ɵngcc2.AsyncPipe], styles: [".wkBreadcrumb[_ngcontent-%COMP%]{color:#fff;background-color:#ededed;height:34px;padding-left:16px}.wkBreadcrumb[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:flex}.wkBreadcrumb[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] + li[_ngcontent-%COMP%]:before{content:\" \\ea0a\";font-family:ucc-icons;font-size:12px;margin-top:1px;margin-right:4px;color:#666}.wkBreadcrumb[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child   span[_ngcontent-%COMP%]{color:#666;cursor:default}.wkBreadcrumbSpanPointer[_ngcontent-%COMP%]{display:flex;color:#0081c6;font-size:12px;cursor:pointer;margin-right:4px}"] });
/** @nocollapse */
BreadCrumbComponent.ctorParameters = () => [
    { type: BreadcrumbService },
    { type: NavigationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BreadCrumbComponent, [{
        type: Component,
        args: [{
                selector: 'ngwk-breadcrumb',
                template: "<div class='wkBreadcrumb alignVerticalMiddle'>\r\n  <li *ngFor='let breadcrumb of breadcrumbs$ | async | slice:-3'>\r\n      <span *ngIf=\"breadcrumb.breadcrumbName\" (click)='navigateTo(breadcrumb)' [ngClass]='spanClass(breadcrumb)'>\r\n          {{ breadcrumb.breadcrumbName }}\r\n      </span>\r\n  </li>\r\n</div>\r\n",
                styles: [".wkBreadcrumb{color:#fff;background-color:#ededed;height:34px;padding-left:16px}.wkBreadcrumb li{display:flex}.wkBreadcrumb li+li:before{content:\" \\ea0a\";font-family:ucc-icons;font-size:12px;margin-top:1px;margin-right:4px;color:#666}.wkBreadcrumb li:last-child span{color:#666;cursor:default}.wkBreadcrumbSpanPointer{display:flex;color:#0081c6;font-size:12px;cursor:pointer;margin-right:4px}\n"]
            }]
    }], function () { return [{ type: BreadcrumbService }, { type: NavigationService }]; }, null); })();

class BreadCrumbModule {
}
BreadCrumbModule.ɵfac = function BreadCrumbModule_Factory(t) { return new (t || BreadCrumbModule)(); };
BreadCrumbModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BreadCrumbModule });
BreadCrumbModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            RouterModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BreadCrumbModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    RouterModule,
                    IconModule
                ],
                declarations: [
                    BreadCrumbComponent
                ],
                exports: [
                    BreadCrumbComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BreadCrumbModule, { declarations: function () { return [BreadCrumbComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        RouterModule,
        IconModule]; }, exports: function () { return [BreadCrumbComponent]; } }); })();

/** Directiva que para declarar [RouterOutlet]{@link https://angular.io/api/router/RouterOutlet} que se coordina con {@link PersistentReuseStrategy}
 * para tener zonas de navegación persistentes. De esta manera, mantienen el estado y cuando se reactivan zonas ya visitadas, se mantiene el estado anterior.
 * Se suele utilizar cuando se declara un {@link TabBarComponent}, para mantener el estado de los diferentes tabs.
 *
 * @example
 * <div>
 *   <ngwk-tab-bar>
 *     ...
 *   </ngwk-tab-bar>
 *   <persistent-router-outlet></persistent-router-outlet>
 * </div>
 */
class PersistentRouterOutletDirective extends RouterOutlet {
    /** @ignore */
    constructor(_reuseStrategy, parentContexts, location, resolver, name, changeDetector) {
        super(parentContexts, location, resolver, name || PRIMARY_OUTLET, changeDetector);
        this._reuseStrategy = _reuseStrategy;
        this._outletLocation = null;
        this._outletLocation = location;
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        if (this.isReuseStrategy(this._reuseStrategy)) {
            this._reuseStrategy.clear(this._outletLocation);
        }
    }
    isReuseStrategy(service) {
        return Type.isFunction(service.clear);
    }
}
PersistentRouterOutletDirective.ɵfac = function PersistentRouterOutletDirective_Factory(t) { return new (t || PersistentRouterOutletDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.RouteReuseStrategy, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ChildrenOutletContexts), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinjectAttribute('name'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
PersistentRouterOutletDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: PersistentRouterOutletDirective, selectors: [["persistent-router-outlet"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
PersistentRouterOutletDirective.ctorParameters = () => [
    { type: RouteReuseStrategy, decorators: [{ type: Optional }] },
    { type: ChildrenOutletContexts },
    { type: ViewContainerRef },
    { type: ComponentFactoryResolver },
    { type: String, decorators: [{ type: Attribute, args: ['name',] }] },
    { type: ChangeDetectorRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PersistentRouterOutletDirective, [{
        type: Directive,
        args: [{
                selector: 'persistent-router-outlet'
            }]
    }], function () { return [{ type: ɵngcc1.RouteReuseStrategy, decorators: [{
                type: Optional
            }] }, { type: ɵngcc1.ChildrenOutletContexts }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ComponentFactoryResolver }, { type: String, decorators: [{
                type: Attribute,
                args: ['name']
            }] }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

class PersistentNavigationModule {
}
PersistentNavigationModule.ɵfac = function PersistentNavigationModule_Factory(t) { return new (t || PersistentNavigationModule)(); };
PersistentNavigationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PersistentNavigationModule });
PersistentNavigationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PersistentNavigationModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    PersistentRouterOutletDirective
                ],
                exports: [
                    PersistentRouterOutletDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PersistentNavigationModule, { declarations: function () { return [PersistentRouterOutletDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [PersistentRouterOutletDirective]; } }); })();

/**
 * Guard que controla si se puede salir de un componente a través de la implementación de la interfaz de [IPendingChanges]{@link IPendingChanges}
 * en el componente que queramos comprobar.
 * Debe declararse en el Routing Module, justo en el mismo lugar donde está el componente que debemos comprobar
 *
 * @example
 * {
 *  path: 'component',
 *  component: Component,
 *  canDeactivate: [PendingChangesGuardService]
 * }
 */
class PendingChangesGuardService {
    /** @ignore */
    constructor(_alertService, _localeService, _navigationService, _modalService) {
        this._alertService = _alertService;
        this._localeService = _localeService;
        this._navigationService = _navigationService;
        this._modalService = _modalService;
        this._pendingChangesQuestion = null;
    }
    /**
     * Método principal que se llama de manera automática para comprobar si el usuario puede salir del componente o no. El componente
     * debe implementar la interfaz [IPendingChanges]{@link IPendingChanges}
     *
     * @param component Componente que implementa la interface de IPendingChanges
     */
    canDeactivate(component) {
        let response = true;
        let lateralModal = this._modalService.activeLateralModal && this._modalService.activeLateralModal.isAlive ? this._modalService.activeLateralModal.modalContainer.contentComponentInstance() : null;
        if (this.hasPendingChanges(component) || this.hasPendingChanges(lateralModal)) {
            this._pendingChangesQuestion = this._alertService.showQuestion(this._localeService.getLocaleString('pending_changes_question'), this._localeService.getLocaleString('pending_changes_title'), this.getPendingChangesQuestionButtons());
            response = new Promise((resolve) => {
                this._pendingChangesQuestion.result.then((result) => resolve(result), (reason) => {
                    if (this._navigationService.backClicked) {
                        this._navigationService.backClicked = false;
                        history.pushState(null, null, location.href);
                    }
                    resolve(reason);
                });
            });
        }
        return response;
    }
    hasPendingChanges(component) {
        return (this.isInstanceofPendingChanges(component) && component.hasPendingChanges);
    }
    getPendingChangesQuestionButtons() {
        let btnYes = {
            content: this._localeService.getLocaleString('pending_changes_affirmative_button'),
            style: NgwkButtonStyle.Primary,
            onClick: () => this._pendingChangesQuestion.close(true),
            id: 'btnYes'
        };
        let btnNo = {
            content: this._localeService.getLocaleString('pending_changes_negative_button'),
            style: NgwkButtonStyle.Secondary,
            onClick: () => this._pendingChangesQuestion.dismiss(false),
            id: 'btnNo'
        };
        return [btnNo, btnYes];
    }
    isInstanceofPendingChanges(object) {
        return object !== null && object.hasPendingChanges !== undefined;
    }
}
PendingChangesGuardService.ɵfac = function PendingChangesGuardService_Factory(t) { return new (t || PendingChangesGuardService)(ɵngcc0.ɵɵinject(ɵngcc5.AlertService), ɵngcc0.ɵɵinject(ɵngcc4.LocaleService), ɵngcc0.ɵɵinject(NavigationService), ɵngcc0.ɵɵinject(ɵngcc6.ModalService)); };
PendingChangesGuardService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PendingChangesGuardService, factory: PendingChangesGuardService.ɵfac });
/** @nocollapse */
PendingChangesGuardService.ctorParameters = () => [
    { type: AlertService },
    { type: LocaleService },
    { type: NavigationService },
    { type: ModalService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PendingChangesGuardService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc5.AlertService }, { type: ɵngcc4.LocaleService }, { type: NavigationService }, { type: ɵngcc6.ModalService }]; }, null); })();

/**
 * Este servicio tiene como objetivo comprobar si una página tiene cambios pendientes de guardar antes de que el usuario la abandone
 */
class BrowserPendingChangesService {
    /**@ignore */
    constructor(_localeService) {
        this._localeService = _localeService;
        this.subscribeOnBeforeUnloadEvent();
    }
    /**
     * Permite registrar un componente que tenga instanciado la interfaz de 'Pending Changes'
     *
     * @param component Componente a registrar que implementa la interfaz de 'Pending Changes'
     * @return
     */
    registerComponent(component) {
        this._lastComponent = null;
        if (this.isInstanceofPendingChanges(component)) {
            this._lastComponent = component;
        }
    }
    isInstanceofPendingChanges(object) {
        return object.hasPendingChanges !== undefined;
    }
    subscribeOnBeforeUnloadEvent() {
        window.onbeforeunload = (event) => this.onBeforeUnloadEvent(event);
    }
    onBeforeUnloadEvent(event) {
        event = event || window.event;
        if (this._lastComponent && this._lastComponent.hasPendingChanges) {
            // For IE and Firefox prior to version 4
            let message = this._localeService.getLocaleString('pending_changes_question');
            if (event) {
                event.returnValue = message;
            }
            // For Safari
            return message;
        }
    }
}
BrowserPendingChangesService.ɵfac = function BrowserPendingChangesService_Factory(t) { return new (t || BrowserPendingChangesService)(ɵngcc0.ɵɵinject(ɵngcc4.LocaleService)); };
BrowserPendingChangesService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BrowserPendingChangesService, factory: BrowserPendingChangesService.ɵfac });
/** @nocollapse */
BrowserPendingChangesService.ctorParameters = () => [
    { type: LocaleService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BrowserPendingChangesService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc4.LocaleService }]; }, null); })();

class NavigationModule {
}
NavigationModule.ɵfac = function NavigationModule_Factory(t) { return new (t || NavigationModule)(); };
NavigationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NavigationModule });
NavigationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        PendingChangesGuardService,
        BrowserPendingChangesService
    ], imports: [[
            BreadCrumbModule,
            SideBarModule,
            TabBarModule,
            PersistentNavigationModule
        ], BreadCrumbModule, SideBarModule, TabBarModule, PersistentNavigationModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavigationModule, [{
        type: NgModule,
        args: [{
                imports: [
                    BreadCrumbModule,
                    SideBarModule,
                    TabBarModule,
                    PersistentNavigationModule
                ],
                exports: [
                    BreadCrumbModule,
                    SideBarModule,
                    TabBarModule,
                    PersistentNavigationModule
                ],
                providers: [
                    PendingChangesGuardService,
                    BrowserPendingChangesService
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NavigationModule, { imports: [BreadCrumbModule, SideBarModule, TabBarModule, PersistentNavigationModule], exports: [BreadCrumbModule, SideBarModule, TabBarModule, PersistentNavigationModule] }); })();

/**
 * Servicio que se encarga de gestionar los components que se pueden reutilizar, manteniendo el estado, en un router-outlet.
 * Basado en [RouteReuseStrategy]{@link https://angular.io/api/router/RouteReuseStrategy}
 *
 * @example
 * NgModule({
 *  ...
 * providers: [
 *  ...
 *  { provide: RouteReuseStrategy, useClass: PersistentReuseStrategy }
 * ]
 * ...
 * })
 * export class AppModule {}
 */
class PersistentReuseStrategy {
    constructor() {
        this._handlers = new Map();
    }
    /** @ignore */
    shouldDetach(route) {
        let canDetach = this.canReuse(route);
        return canDetach;
    }
    /** @ignore */
    shouldAttach(route) {
        let result = false;
        if (this.canReuse(route)) {
            const key = this.calcKey(route);
            if (key) {
                result = this._handlers.has(key);
            }
        }
        return result;
    }
    /** @ignore */
    store(route, handle) {
        if (this.canReuse(route) && handle) {
            const key = this.calcKey(route);
            if (key) {
                this._handlers.set(key, {
                    handle: handle,
                    routeSnapshot: route,
                    container: handle.componentRef.location
                        .nativeElement.parentNode
                });
            }
        }
    }
    /** @ignore */
    retrieve(route) {
        let result = null;
        if (this.canReuse(route)) {
            const key = this.calcKey(route);
            if (key) {
                result = this._handlers.has(key) ? this._handlers.get(key).handle : null;
            }
        }
        return result;
    }
    /** @ignore */
    shouldReuseRoute(future, curr) {
        return future.routeConfig === curr.routeConfig;
    }
    /** Método para eliminar los componentes que ya no estan en uso.
     * Se llama des del OnDestroy de {@link PersistentRouterOutletDirective}
     *
     * @param outletLocation RouterOutlet des de donde se llama al clear.
     * */
    clear(outletLocation) {
        let handlersKey = this.getHandlersKeyByRouterOutlet(outletLocation);
        handlersKey.forEach((key) => this._handlers.delete(key));
    }
    canReuse(route) {
        let result = route.routeConfig &&
            !route.routeConfig.loadChildren &&
            route.routeConfig.data &&
            route.routeConfig.data.reuse;
        return result;
    }
    calcKey(route) {
        const url = route.pathFromRoot
            .map(x => x.url.map(u => u.path).join("/"))
            .join(";");
        if (!url.length) {
            return undefined;
        }
        return url;
    }
    getHandlersKeyByRouterOutlet(outletLocation) {
        let outletContainer = outletLocation.element.nativeElement.parentNode;
        let handlersKey = Array.from(this._handlers.keys()).filter((key) => outletContainer === this._handlers.get(key).container);
        return handlersKey;
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { BreadCrumbComponent, BreadCrumbModule, BreadcrumbService, BrowserPendingChangesService, NavigationModule, NavigationService, PendingChangesGuardService, PersistentNavigationModule, PersistentReuseStrategy, PersistentRouterOutletDirective, SideBarComponent, SideBarItemComponent, SideBarModule, TabBarComponent, TabBarItemComponent, TabBarModule };

